import React from 'react';
import './App.scss';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css"; 
import Navbar from './components/Navbar/Navbar.tsx';
import UserRoutes from './routes/UserRoutes.tsx';
import { BrowserRouter } from 'react-router-dom';
import Footer from './components/Footer/Footer.tsx';

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <UserRoutes/>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;
